import api, { ApiResponse } from './api';

export interface Holiday {
  id: number;
  holidayId: number;
  name: string;
  holidayName: string;
  date: string;
  holidayDate: string;
  endDate?: string;
  holidayType?: string;
  description?: string;
  isPaid: boolean;
  isActive: boolean;
}

export interface HolidayCreateDto {
  name: string;
  date: string;
  endDate?: string;
  holidayType?: string;
  description?: string;
  isPaid?: boolean;
}

export interface HolidayUpdateDto {
  name?: string;
  date?: string;
  endDate?: string;
  holidayType?: string;
  description?: string;
  isPaid?: boolean;
  isActive?: boolean;
}

const holidayService = {
  getAll: async (year?: number): Promise<ApiResponse<Holiday[]>> => {
    const params = year ? `?year=${year}` : '';
    return api.get(`/holidays${params}`);
  },

  getById: async (id: number): Promise<ApiResponse<Holiday>> => {
    return api.get(`/holidays/${id}`);
  },

  getUpcoming: async (days: number = 30): Promise<ApiResponse<Holiday[]>> => {
    return api.get(`/holidays/upcoming?days=${days}`);
  },

  create: async (data: HolidayCreateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.post('/holidays', data);
  },

  update: async (id: number, data: HolidayUpdateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.put(`/holidays/${id}`, data);
  },

  delete: async (id: number): Promise<ApiResponse<{ id: number }>> => {
    return api.delete(`/holidays/${id}`);
  },
};

export default holidayService;
